<template>
  <div>
    <b-overlay
      :show="isLoading"
      spinner-variant="primary"
      spinner-larger
    >
      <b-row
        xl="12"
        sm="12"
      >
        <b-col
          v-for="(deviceList, index) in datas"
          :key="index"
          cols="6"
          md="6"
        >
          <!-- <b-card>
        </b-card>
         -->
          <b-card title="">
            <b class="pr-1">{{ deviceList.device_list.device_information.site_name }}</b> <span class="dot normal" /> Normal <span class="dot abnormal" /> Abnormal
            <b class="sidebar-right">{{ datenow }}</b>
          </b-card>
          <b-row
            xl="12"
            sm="12"
          >
            <b-col
              sm="4"
              md="4"
            >
              <b-row
                xl="4"
                sm="4"
              >
                <b-col
                  cols="12"
                  md="12"
                >
                  <b-card title="PH">
                    <!-- apex chart -->
                    <vue-apex-charts
                      type="radialBar"
                      height="205"
                      class="my-2"
                      :options="lineChartSimpleTemperaturePh.chartOptions"
                      :series="[valueToPercent(lineChartSimpleTemperaturePh.series[index].data)]"
                    />
                  </b-card>
                </b-col>
              </b-row>
            </b-col>
            <b-col md="8">
              <b-row
                xl="4"
                sm="4"
              >
                <b-col
                  v-for="(val, key) in filterDevices(deviceList.device_list.device_realtime)"
                  :key="key"
                  cols="6"
                  md="6"
                >
                  <DeviceCard
                    :device="val"
                    :has-limit="val.device_name === 'Debit' ? false : true"
                    :limit="limitDevices[val.device_name]"
                  />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BOverlay, BRow, BCol,
} from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import DeviceCard from './components/DeviceCard.vue'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
const getCurrentTime = () => moment(String(new Date())).format("dddd, DD MMM' YYYY LTS")

export default {
  components: {
    VueApexCharts,
    BCard,
    BOverlay,
    BRow,
    BCol,
    DeviceCard,
  },
  data() {
    return {
      datas: [],
      datenow: moment(String(new Date())).format("dddd, DD MMM' YYYY LTS"),
      show: false,
      isLoading: false,
      isInitialLoad: true,
      currentTimeInterval: null,
      dashboardInterval: null,
      limitDevices: {
        COD: {
          min: 0,
          max: 100,
        },
        NH3N: {
          min: 0.00001,
          max: 10,
        },
        TSS: {
          min: 0,
          max: 150,
        },
        Debit: {
          min: 0,
          max: 100,
        },
      },
      lineChartSimpleTemperaturePh: {
        series: [
          {
            name: 'Temperature',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 245,
            type: 'radialBar',
            sparkline: {
              enabled: true,
            },
            dropShadow: {
              enabled: true,
              blur: 3,
              left: 1,
              top: 1,
              opacity: 0.1,
            },
          },
          colors: [$goalStrokeColor2],
          plotOptions: {
            radialBar: {
              offsetY: -10,
              startAngle: -150,
              endAngle: 150,
              hollow: {
                size: '57%',
              },
              track: {
                background: $strokeColor,
                strokeWidth: '50%',
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  color: $textHeadingColor,
                  fontSize: '2.86rem',
                  fontWeight: '600',
                  formatter(val) {
                    return parseFloat(((val * (10 - 2)) / 100 + 2).toFixed(2))
                  },
                },
              },
            },
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              type: 'horizontal',
              shadeIntensity: 0.5,
              gradientToColors: [$themeColors.success],
              inverseColors: true,
              opacityFrom: 1,
              opacityTo: 1,
              stops: [0, 100],
            },
          },
          stroke: {
            lineCap: 'round',
          },
          grid: {
            padding: {
              bottom: 30,
            },
          },
        },
      },
    }
  },
  beforeDestroy() {
    if (this.currentTimeInterval) clearInterval(this.currentTimeInterval)
    if (this.dashboardInterval) clearInterval(this.dashboardInterval)
  },
  created() {
    this.currentTimeInterval = setInterval(() => this.updateCurrentTime(), 1000)
    this.dashboardInterval = setInterval(() => this.getData(), 30000)
    this.getData()
  },
  methods: {
    filterDevices(item) {
      const params = ['cod', 'nh3n', 'tss', 'debit']
      return item.filter(v => v.device_name && params.includes(v.device_name.toLowerCase()))
    },
    updateCurrentTime() {
      this.datenow = getCurrentTime()
    },
    valueToPercent(val) {
      return ((val - 2) * 100 / (10 - 2)).toFixed(2)
    },
    getData() {
      this.isLoading = this.isInitialLoad // Hanya set isLoading menjadi true pada initial load

      const api = process.env.VUE_APP_DEVICE_API
      const headers = {
        authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      }

      axios.get(`${api}/internal/dashboard/sparing-multiple`, { headers })
        .then(response => {
          if (response.data && response.data.data && response.data.data.length > 0) {
            this.datas = response.data.data
            this.lineChartSimpleTemperaturePh.series = this.datas.map(device => ({
              name: device.device_list.device_information.site_name,
              data: device.device_list.device_realtime
                .filter(realtime => realtime.device_name === 'PH')
                .map(phData => phData.device_value),
            }))
          } else {
            console.error('Invalid response format or empty data array.')
          }

          this.isLoading = false // Set isLoading menjadi false setelah data diterima
          this.isInitialLoad = false // Tandai initial load telah selesai
        })
        .catch(error => {
          console.error('Error fetching data:', error)
          this.isLoading = false // Set isLoading menjadi false jika terjadi error
          this.isInitialLoad = false // Tandai initial load telah selesai
        })
    },
  },
}
</script>

<style lang="scss">
.my-custom-class .card-title {
  color: white;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  display: inline-block;
}

.normal {
  background-color: #03ff2d;
}

.abnormal {
  background-color: #FC4C02;
}
</style>
